import { Fragment } from 'preact/jsx-runtime'

import type { TeaserFooterProps } from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { IconUse } from '@bonniernews/dn-design-system-web/components/icon-sprite/icon-sprite.tsx'

interface TeaserFooterComponentProps extends TeaserFooterProps {
  footerVariant?: 'informationText' | 'podcast' | 'default'
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-footer](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-footer)
 * - Storybook: [Subcomponents > TeaserFooter](https://designsystem.dn.se/?path=/docs/section-subcomponents-teaserfooter--docs)
 */
export const TeaserFooter = (props: TeaserFooterComponentProps) => {
  const { footerVariant, attributes = {}, classNames = '' } = props
  const componentClassName = 'ds-teaser-footer'

  const classes = formatClassString([componentClassName, `${componentClassName}--${footerVariant}`, classNames])

  return footerVariant !== 'default' ? (
    <div className={classes} {...attributes}>
      {footerVariant === 'informationText' && <InformationText {...props} />}

      {footerVariant === 'podcast' && (
        <>
          <IconUse iconName='play_arrow-filled' />
          <div>
            <span className={`${componentClassName}__title`}>Lyssna på avsnittet</span>
            <InformationText {...props} />
          </div>
        </>
      )}
    </div>
  ) : null
}

function InformationText({ duration, publicationTime, sectionName }: TeaserFooterProps) {
  const strings = [duration, publicationTime, sectionName].filter(Boolean)

  if (strings.length === 0) {
    return null
  }

  return (
    <div className='ds-teaser-footer__notes'>
      {strings.map((text, index) => (
        <Fragment key={index}>
          {text}
          {index < strings.length - 1 && ' • '}
        </Fragment>
      ))}
    </div>
  )
}
